module.exports = __webpack_public_path__ + "media/aboutMob.d604af63.mp4";